import { SetStateAction, useMemo } from "react";
import { Dispatch } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../shadcn/select";
import { PageChanger } from "../PageChanger";

export const SizeOptions = [
  { label: "5", value: "5" },
  { label: "10", value: "10" },
  { label: "15", value: "15" },
  { label: "20", value: "20" },
  { label: "25", value: "25" },
  { label: "30", value: "30" },
];

export type TableControlsFooterProps = {
  data?: Record<string, any> & {
    total?: number | null;
    pages?: number | null;
  };
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  pageSize: number;
  onPageSizeChange: (value: { label: string; value: string }) => void;
  onPrefetchNextPage?: () => void;
  disablePageSizeSelector?: boolean;
  className?: string;
};

export const TableControlsFooter = ({
  data,
  currentPage,
  setCurrentPage,
  pageSize,
  onPageSizeChange,
  onPrefetchNextPage,
  disablePageSizeSelector = false,
  className = "flex justify-center items-center w-full mt-4 relative",
}: TableControlsFooterProps) => {
  const currentPageText = useMemo(() => {
    return data?.items && data.items.length > 0
      ? `${(currentPage - 1) * pageSize + 1}-${Math.min(
          currentPage * pageSize,
          data?.total || 0
        )}`
      : "0";
  }, [currentPage, pageSize, data]);

  return (
    <div className={className}>
      <div className="absolute left-0 text-sm text-muted-foreground">
        <span>{currentPageText}</span>
        {" of"} <span>{data?.total || 0}</span>
      </div>
      <PageChanger
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={data?.pages || 1}
        maxWidth="3.5rem"
        onPrefetchNextPage={onPrefetchNextPage}
        size="sm"
      />
      {!disablePageSizeSelector && (
        <div className="absolute right-0">
          <div className="flex gap-2 items-center">
            <span className="text-xs text-muted-foreground">
              Lines per page
            </span>
            <Select
              value={String(pageSize)}
              onValueChange={(value) => {
                const option = SizeOptions.find((opt) => opt.value === value);
                if (option) {
                  onPageSizeChange(option);
                }
              }}
            >
              <SelectTrigger data-testid="page-size" className="w-auto h-6! ">
                <SelectValue />
              </SelectTrigger>
              <SelectContent align="end">
                {SizeOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};
